import { DocumentAddData, DocumentGetApiResponse, DocumentListApiResponse, DocumentUpdateData } from "../context/DocumentContext/constants";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	ADD: "/cms/add-document",
	REMOVE: "/cms/remove-document",
	LIST: "/cms/get-documents",
	GET: "/cms/get-document-details",
	UPDATE: "/cms/update-document",
};

export class DocumentService {
	static async addDocument(docData: DocumentAddData) {
		const formData = new FormData();

		formData.append("categoryId", docData.categoryId);

		if (docData.displayOrder !== undefined && docData.displayOrder !== null) {
			formData.append("displayOrder", docData.displayOrder.toString());
		}

		if (docData.documents?.length === 1 && docData.documentName?.trim()) {
			formData.append("documentName", docData.documentName);
		}

		docData.documents?.forEach((file) => {
			formData.append("documents", file);
		});

		const response = await axiosInstance.post(`${ENDPOINTS.ADD}`, formData);
		return response.data;
	}

	static async removeDocument(docId: string) {
		const response = await axiosInstance.delete(`${ENDPOINTS.REMOVE}?docId=${docId}`);
		return response.data;
	}

	static async getDocumentList(categoryId?: string): Promise<DocumentListApiResponse> {
		const params = categoryId ? { categoryId } : {};
		const response = await axiosInstance.get(`${ENDPOINTS.LIST}`, { params });

		return response.data;
	}

	static async getDocumentDetail(docId: string): Promise<DocumentGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.GET}?docId=${docId}`);
		return response.data;
	}

	static async updateDocument(data: DocumentUpdateData) {
		const formData = new FormData();

		formData.append("documentId", data.documentId);

		if (data.documentName?.trim()) {
			formData.append("documentName", data.documentName);
		}

		if (data.document) {
			formData.append("document", data.document);
		}

		if (data.displayOrder !== undefined && data.displayOrder !== null) {
			formData.append("displayOrder", data.displayOrder.toString());
		}

		const response = await axiosInstance.patch(`${ENDPOINTS.UPDATE}`, formData);
		return response.data;
	}
}